// extracted by mini-css-extract-plugin
module.exports = {"sun":"pw830gEi","moon":"GIju0k8k","sunRise":"Waqhu6Pb"};